export default "__VITE_ASSET__CSr9fbz2__"